var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormItem',{attrs:{"label":"和其他实验：","prop":"experimentType","rules":[
      {
        required: true,
        message: '请选择和其他实验的关系',
        trigger: 'change'
      }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('RadioGroup',{attrs:{"type":"button","button-style":"solid"},model:{value:(_vm.formData.experimentType),callback:function ($$v) {_vm.$set(_vm.formData, "experimentType", $$v)},expression:"formData.experimentType"}},[_c('Radio',{attrs:{"label":"0","disabled":_vm.readonly}},[_vm._v("互斥")]),_c('Radio',{attrs:{"label":"1","disabled":_vm.readonly}},[_vm._v("并行")])],1)],1)],1),(!_vm.isThirdPayCapabilitySelected)?_c('FormItem',{attrs:{"label":"注册剧目：","prop":"playIdsUnlimited","rules":[
      {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (
            _vm.formData.playIdsUnlimited !== 0 &&
            _vm.formData.playIdsUnlimited !== 1
          ) {
            callback('请选择注册剧目')
          } else {
            callback()
          }
        }
      }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('RadioGroup',{attrs:{"type":"button","button-style":"solid","disabled":_vm.readonly},on:{"on-change":() => {
            _vm.formData.playIds = []
            _vm.handleGetPlayBatch()
          }},model:{value:(_vm.formData.playIdsUnlimited),callback:function ($$v) {_vm.$set(_vm.formData, "playIdsUnlimited", $$v)},expression:"formData.playIdsUnlimited"}},[_c('Radio',{attrs:{"label":0,"disabled":_vm.readonly}},[_vm._v("不限")]),_c('Radio',{attrs:{"label":1,"disabled":_vm.readonly}},[_vm._v("指定剧目")])],1)],1)],1):_vm._e(),(!_vm.isThirdPayCapabilitySelected && _vm.formData.playIdsUnlimited)?_c('FormItem',{attrs:{"prop":"playIds","rules":[
      {
        message: '请选择注册剧目',
        trigger: 'change',
        validator(rule, value, callback) {
          if (!_vm.formData.playIds || _vm.formData.playIds.length === 0) {
            callback('请选择注册剧目')
          } else {
            callback()
          }
        }
      }
    ]}},[_c('playCascader',{ref:"playCnRef",staticStyle:{"width":"300px"},attrs:{"disabled":_vm.readonly,"value":_vm.formData.playIds},on:{"update:value":function($event){_vm.formData.playIds = $event}}})],1):_vm._e(),(!_vm.isThirdPayCapabilitySelected)?_c('FormItem',{attrs:{"label":"推送人群"}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('RadioGroup',{attrs:{"type":"button","button-style":"solid","disabled":_vm.readonly},on:{"on-change":_vm.handleCrowdModeChange},model:{value:(_vm.formData.crowdMode),callback:function ($$v) {_vm.$set(_vm.formData, "crowdMode", $$v)},expression:"formData.crowdMode"}},[_c('Radio',{attrs:{"label":"all","disabled":_vm.readonly || _vm.isRechargeTemplateCapabilitySelected}},[_vm._v("不限")]),_c('Radio',{attrs:{"label":"selected","disabled":_vm.readonly}},[_vm._v("选择人群包")])],1)],1)],1):_vm._e(),(_vm.formData.crowdMode === 'selected')?_c('FormItem',{attrs:{"label":_vm.isThirdPayCapabilitySelected ? '人群包' : '',"prop":"crowdIds","rules":[
      {
        message: '请选择人群包',
        trigger: 'change',
        validator(rule, value, callback) {
          if (!_vm.formData.crowdIds || !_vm.formData.crowdIds.length) {
            callback('请选择人群包')
          } else {
            callback()
          }
        }
      }
    ]}},[_c('Select',{staticStyle:{"width":"300px"},attrs:{"placeholder":"请输入人群包名称搜索","filterable":"","multiple":"","clearable":"","disabled":_vm.readonly},model:{value:(_vm.formData.crowdIds),callback:function ($$v) {_vm.$set(_vm.formData, "crowdIds", $$v)},expression:"formData.crowdIds"}},_vm._l((_vm.crowdOptions),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id,"label":item.name}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])}),1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }